<template>
  <div class="activity-info-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('活动详情') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content" v-if="dataInfo.title">
      <img :src="dataInfo.banner" alt="" style="width: 100%; display: block" />
      <div class="info-title">
        <span>{{ dataInfo.title }}</span>
      </div>
      <div class="title-box">
        <div class="title-bg">{{ $t('活动详情') }}</div>
      </div>
      <div class="tables" v-html="dataInfo.content"></div>
      <div class="title-box">
        <div class="title-bg">{{ $t('活动说明') }}</div>
      </div>
      <div class="tables" v-html="dataInfo.memo"></div>
      <div class="bonsf">
        <div v-if="$store.state.token" class="btsdn" @click="doactivityapply">{{ $t('立即申请') }}</div>
        <div v-else class="btsdn" @click="$parent.goNav('/login')">{{ $t('前往登录') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'activityInfo',
  data() {
    return { dataInfo: {} };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(async (res) => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
        }
        if (res.code === 200) {
          const info = res.data;
          const translate_arr = await translateText([info.title, info.content]);
          info.title = translate_arr[0];
          info.content = translate_arr[1];
          that.dataInfo = info;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.hideLoading();
        that.showTost(1, res.message);
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
.activity-info-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 1.6rem;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .info-title {
      height: 1.6rem;
      background-image: url("/static/image/new/activity-title-bg.png");
      width: 100%;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .27rem;
      span {
        font-size: 0.53rem;
        font-family: LogoSC Unbounded Sans;
        background: linear-gradient(0deg, #FFFFFF 0%, #FFF7C3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .title-box {
      display: flex;
      justify-content: center;
      margin-top: .51rem;
      .title-bg {
        background-image: url("/static/image/new/activity-btn-bg.png");
        background-size: 100% 100%;
        width: 2.88rem;
        height: .91rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.43rem;
        font-weight: bold;
      }
    }
  }
}
.tables {
  font-size: .32rem;
  box-sizing: border-box;
  line-height: 1.5;

}
.bonsf {
  position: absolute;
  left: 5%;
  bottom: 10px;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  padding: 0 .2rem;
  border-radius: 8px;
  .btsdn {
    display: flex;
    width: 100%;
    height: 1.17rem;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
    //border: 0.03rem solid rgba(255, 255, 255, 0.10);
    font-size: 0.43rem;
    padding: 0 20px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityInfo.vue